import TechTag from './TechTag';

export default function TechStack({ technologies }) {
  return (
    <div className="flex flex-wrap gap-2 mt-auto">
      {technologies.map((tech, techIndex) => (
        <TechTag key={techIndex} technology={tech} />
      ))}
    </div>
  );
}